export default __webpack_public_path__ + "images/b7e90b76bfefb25f9ee10d21da0ae31f.svg";